import '../Profile.scss';

import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { editLocation, loadProvider } from 'actions/provider';
import Checkbox from 'atoms/checkbox';
import Dropdown from 'atoms/dropdown';
import Input from 'atoms/input';
import ModalContent from 'atoms/modal-content';
import toast from 'atoms/toast';
import { HourBlocks } from 'organisms/HourBlocks';
import {
  editLocationForm,
  initLocationForm,
} from 'store/reducers/locationForm';
import { formatWebsite, prettifyHoursData } from 'util';

import { formatApiHours } from '../util';

function EditInfoModal({ isOpen, openModal }) {
  const dispatch = useDispatch();
  const {
    provider: providerMain,
    core,
    geo,
  } = useSelector((state) => state.main);
  const providerTypeOptions = providerMain.type;
  const animalTypesOptions = core.type;
  const providerInfo = useSelector((state) => state.provider);
  const locationInfo = providerInfo.locations[0];
  const locationForm = useSelector((state) => state.locationForm);
  const [hours, setHours] = useState({
    Monday: {},
    Tuesday: {},
    Wednesday: {},
    Thursday: {},
    Friday: {},
    Saturday: {},
    Sunday: {},
  });

  const canContinue =
    locationForm.typeIds.length &&
    locationForm.animalTypeIds.length &&
    Object.entries(locationForm).every(([key, value]) => {
      if (key === 'website' || key === 'neighborhood') return true;
      return value;
    });

  useEffect(() => {
    if (locationInfo) {
      setHours(formatApiHours(locationInfo.hours, hours));
      dispatch(initLocationForm(locationInfo));
    }
  }, [locationInfo]);

  const onSave = () => {
    const body = {
      ...locationForm,
      email: locationInfo.email,
      countryCodeId: locationForm.countryCodeId.code.id,
      hours: prettifyHoursData(hours),
      website: formatWebsite(locationForm.website),
    };

    dispatch(editLocation(body)).then(({ success }) => {
      if (success) {
        dispatch(loadProvider());
        toast({ text: 'Information saved!' });
      }
    });
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => openModal(false)}
      shouldCloseOnOverlayClick
      className="edit-info-modal"
    >
      <ModalContent
        title="Business information"
        isButtonDisabled={!canContinue}
        primaryButton="Save"
        secondaryButton="Close"
        primaryButtonAction={onSave}
        secondaryButtonAction={() => openModal(false)}
        onClose={() => openModal(false)}
      >
        <Input
          id="name"
          label="Name"
          onChange={(value) =>
            dispatch(editLocationForm({ key: 'name', value }))
          }
          value={locationForm.name}
        />
        <Input
          id="website"
          label="Website"
          className="mt-25"
          onChange={(value) =>
            dispatch(editLocationForm({ key: 'website', value }))
          }
          value={locationForm.website}
        />
        <div className="phone-container mb-25">
          <Dropdown
            id="countryCode"
            label="Phone"
            className="country-code-input"
            items={geo.countryCode}
            onClick={(value) =>
              dispatch(editLocationForm({ key: 'countryCodeId', value }))
            }
            value={locationForm.countryCodeId.code}
          />
          <Input
            id="phone"
            className="no-label"
            onChange={(value) =>
              dispatch(editLocationForm({ key: 'phoneNumber', value }))
            }
            value={locationForm.phoneNumber}
            isNumber
          />
        </div>
        <Dropdown
          id="providerType"
          label="Provider type"
          className="mt-32"
          placeholder="Boarder, Groomer, Veterinarian, etc"
          items={providerTypeOptions}
          onClick={({ id }) =>
            dispatch(editLocationForm({ key: 'typeIds', value: [id] }))
          }
          value={
            providerTypeOptions.find(
              (el) => el.id === locationForm.typeIds[0]
            ) || ''
          }
        />
        <div className="flex-column mt-32 mb-0">
          <p className="mb-15 mt-10 bold f18">Animal cared for</p>
          <div className="flex-row flex-wrap">
            {animalTypesOptions.map((el) => (
              <div key={el.value} className="checkbox-container__checkbox">
                <Checkbox
                  size="small"
                  className="mr-25"
                  id={el.id}
                  value={locationForm.animalTypeIds.includes(el.id)}
                  onClick={({ id }) => {
                    const ids = [...locationForm.animalTypeIds];
                    if (ids.includes(id)) {
                      const index = ids.indexOf(id);
                      ids.splice(index, 1);
                    } else {
                      ids.push(id);
                    }
                    dispatch(
                      editLocationForm({ key: 'animalTypeIds', value: ids })
                    );
                  }}
                  text={el.value}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="mt-50">
          <HourBlocks hours={hours} setHours={setHours} />
        </div>
      </ModalContent>
    </Modal>
  );
}

export default EditInfoModal;
